import React from 'react';
import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import { useTestSeriesData } from './useTestSeriesData';

const FeatureCardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  padding: 100px 0;
  align-items: center;
  justify-content: center;

  ${mediaQuery.uptoMobile} {
    gap: 40px;
    padding: 40px 0;
  }
`;

const FeatureCardContainer = styled.div`
  width: 70%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;

  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    width: 100%;
  }
`;
const FeatureCardLeftContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px;

  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;
const FeatureCardRightContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px;

  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;
const FeatureCardTag = styled.div`
  border-radius: 8px;
  padding: 12px 16px;
  background: var(--color-green-bg);
  color: var(--color-green-focus);
  font-weight: 700;
  font-size: 18px;
  line-height: 120%;
  text-transform: uppercase;

  ${mediaQuery.uptoMobile} {
    padding: 8px 12px;
    font-size: 14px;
    letter-spacing: 0%;
    text-align: center;
  }
`;

const FeatureCardLeftContainerTitle = styled.p`
  font-weight: 700;
  font-size: 60px;
  line-height: 120%;
  letter-spacing: -2%;
  text-align: center;
  color: var(--color-primary-focus);

  ${mediaQuery.uptoMobile} {
    font-size: 39px;
  }
`;
const FeatureCardLeftContainerDescription = styled.p`
  font-weight: 400;
  font-size: 28px;
  line-height: 150%;
  letter-spacing: -1px;
  text-align: center;
  color: var(--color-text-secondary);

  ${mediaQuery.uptoMobile} {
    font-size: 18px;
  }
`;
const FeatureImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const FeatureCard = ({
  tag,
  title,
  description,
  image
}: {
  title: string;
  image: string;
  description: string;
  tag: string;
}) => {
  return (
    <FeatureCardContainer>
      <FeatureCardLeftContainer>
        {tag && <FeatureCardTag>{tag}</FeatureCardTag>}
        <FeatureCardLeftContainerTitle>{title}</FeatureCardLeftContainerTitle>
        <FeatureCardLeftContainerDescription>
          {description}
        </FeatureCardLeftContainerDescription>
      </FeatureCardLeftContainer>
      <FeatureCardRightContainer>
        <FeatureImage src={image} />
      </FeatureCardRightContainer>
    </FeatureCardContainer>
  );
};
const FeatureCardsSection = () => {
  const { data } = useTestSeriesData();
  if (!data?.featureCard || !Array.isArray(data.featureCard)) return null;
  const { featureCard } = data;
  return (
    <FeatureCardsWrapper>
      {featureCard.map((feature) => {
        const { title, description, image, tag } = feature;
        if (!title || !description || !image?.url) {
          return null;
        }

        return (
          <FeatureCard
            key={title}
            title={title}
            description={description}
            image={image.url}
            tag={tag}
          />
        );
      })}
    </FeatureCardsWrapper>
  );
};

export default FeatureCardsSection;
